import React from 'react';
import cn from 'classnames';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import classes from './filter-controllers.scss';
const FilterControllers = ({
  isFilterPopupOpen,
  onOpenCategories,
  onOpenFilterPanel,
  onOpenSorting,
  hideCategories = false
}) => {
  return !hideCategories ? /*#__PURE__*/React.createElement("div", {
    className: cn(classes.filterWrapper, {
      [classes.openedFilter]: !isMobile() && isFilterPopupOpen,
      [classes.filterWrapperCategoriesHidden]: hideCategories
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.bigBlock,
    onClick: onOpenCategories
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconCategory
  }), "Categories"), /*#__PURE__*/React.createElement("div", {
    className: classes.wrapperBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smallBlock,
    onClick: onOpenFilterPanel
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconFilter
  }), "Filter by"), /*#__PURE__*/React.createElement("div", {
    className: classes.smallBlock,
    onClick: onOpenSorting
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconSorting
  }), "Sort by"))) : null;
};
export default FilterControllers;